module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cards row gutter-small"
  }, [(_vm.data.length === 0) ? _c('loading-spinner', {
    staticClass: "column"
  }) : _vm._e(), _vm._l((_vm.data), function(d) {
    return _c('div', {
      staticClass: "columns",
      class: _vm.classes
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-section"
    }, [(d.callback) ? _c('a', {
      class: d.callback.class,
      on: {
        "click": function($event) {
          return d.callback.func()
        }
      }
    }) : _vm._e(), _c('b', {
      domProps: {
        "innerHTML": _vm._s(d.title)
      }
    }), _c('h1', {
      style: ({
        color: d.color
      }),
      domProps: {
        "innerHTML": _vm._s(d.value)
      }
    }), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(d.extra)
      }
    })])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ba6d015c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Cards.vue
// module id = 2657
// module chunks = 1